import * as React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

export interface State {
    showItems: boolean;
}

export interface Props {
    listItems: any[];
    onClick: (listItem: any) => void;
    position?: string;
    style?: string;
    width?: string;
}

export default class DropDownButton extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            showItems: false
        };
    }

    showSubmenuHandle = () => {
        this.setState({ showItems: !this.state.showItems });
    };

    render() {
        return (
            <>
                <div className={`btn-group mr-1 ${this.state.showItems ? `show` : ``}`}>
                    <button
                        onClick={this.showSubmenuHandle}
                        className="btn btn-secondary btn-sm dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded={this.state.showItems ? true : false}
                    >
                        <FontAwesomeIcon className="mt-1 mr-2" icon={faDownload} />
                    </button>
                    <div
                        className={`dropdown-menu dropdown-menu-${this.props.position ? this.props.position : `right`} py-0 px-0 
                            ${this.state.showItems ? `show` : ``}`}
                        aria-labelledby="dropdownMenuButton"
                        style={this.props.width ? { width: this.props.width } : { width: "auto" }}
                    >
                        {this.props.listItems.map((listItem, index) => (
                            <button
                                key={index}
                                className={`btn btn-${this.props.style ? this.props.style : `dark`} btn-sm rounded-0 mx-0 my-0 btn-block`}
                                onClick={() => {
                                    this.props.onClick(listItem);
                                    this.setState({ showItems: false });
                                }}
                            >
                                {listItem.name}
                            </button>
                        ))}
                    </div>
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/DropdownButton.tsx